import {AppShell, Button, Group} from "@mantine/core";
import CurrentUser from "./CurrentUser";
import classes from "./Header.module.css";
import ToggleButton from "./ToggleButton";
import {useContext} from "react";
import LayoutContext from "../LayoutContext";
import {IconArrowBack} from "@tabler/icons-react";
import {useNavigate} from "react-router-dom";

/**
 * Standard application header
 * @author Kacper Faber
 * @since 0.1.1
 * @constructor
 */
function Header() {
    const layoutContext = useContext(LayoutContext);

    /**
     * Navigate function from react-router-dom
     * @author Kacper Faber
     * @since 0.1.8
     */
    const navigate = useNavigate();

    /**
     * On back button is clicked, we're going back to the previous page.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const onBackClicked = () => {
        navigate(-1);
    };

    /**
     * Render back button is subpage.
     * Otherwise - null.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const renderBackButton = () => {
        if (!layoutContext.isSubPage) {
            return null;
        }

        return (
            <Button
                variant="subtle"
                children={<IconArrowBack/>}
                onClick={onBackClicked}
            />
        );
    }

    return (
        <AppShell.Header bg="header.0" className={classes.header} withBorder={false}>
            <Group h="100%" px="md" justify="space-between">
                { layoutContext.isSubPage ? null : <ToggleButton/> }

                { renderBackButton() }

                <CurrentUser/>
            </Group>
        </AppShell.Header>
    );
}

export default Header;

